.emojiIcon {
  transform: scale(0.6);

  &.selected {
    transform: scale(1);
  }
}

.numberIcon {
  transform: scale(0.8);

  &.selected {
    transform: scale(1);
  }
}
